<section id="contact" class="contact-section">
  <p-toast></p-toast>
  <div class="container">
    <div class="contact-header text-center" appAnimateOnScroll="fade-in-up">
      <h2 class="section-title">{{ 'contact.TITLE' | translate }}</h2>
      <p class="section-subtitle">{{ 'contact.SUBTITLE' | translate }}</p>
    </div>

    <div class="contact-card">
      <div class="contact-form-container" appAnimateOnScroll="fade-in-left">
        <h3>{{ 'contact.GET_IN_TOUCH' | translate }}</h3>
        <form [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="contact-form">
          <div class="form-group">
            <label for="name">{{ 'contact.form.NAME' | translate }}</label>
            <input type="text" id="name" formControlName="name" [placeholder]="'contact.form.NAME_PLACEHOLDER' | translate">
          </div>
          <div class="form-group">
            <label for="email">{{ 'contact.form.EMAIL' | translate }}</label>
            <input type="email" id="email" formControlName="email" [placeholder]="'contact.form.EMAIL_PLACEHOLDER' | translate">
          </div>
          <div class="form-group">
            <label for="phone">{{ 'contact.form.PHONE' | translate }}</label>
            <input type="tel" id="phone" formControlName="phone" [placeholder]="'contact.form.PHONE_PLACEHOLDER' | translate">
          </div>
          <div class="form-group">
            <label for="subject">{{ 'contact.form.SUBJECT' | translate }}</label>
            <input type="text" id="subject" formControlName="subject" [placeholder]="'contact.form.SUBJECT_PLACEHOLDER' | translate">
          </div>
          <div class="form-group">
            <label for="message">{{ 'contact.form.MESSAGE' | translate }}</label>
            <textarea id="message" formControlName="message" rows="5" [placeholder]="'contact.form.MESSAGE_PLACEHOLDER' | translate"></textarea>
          </div>
          <button type="submit" class="btn btn-submit" [disabled]="contactForm.invalid || isSubmitting">
            @if (!isSubmitting) {
              <span>{{ 'contact.form.SEND_BUTTON' | translate }}</span>
            }
            @if (isSubmitting) {
              <span>{{ 'common.sending' | translate }}</span>
            }
          </button>
        </form>
      </div>

      <div class="contact-info-container" appAnimateOnScroll="fade-in-right">
        <h3>{{ 'contact.CONTACT_INFO' | translate }}</h3>
        <div class="info-items">
          <div class="info-item">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="20" height="16" x="2" y="4" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>
            <div>
              <h4>{{ 'contact.info.EMAIL_TITLE' | translate }}</h4>
              <a [href]="'mailto:' + ('contact.info.EMAIL_DETAIL' | translate)" class="email-link">{{ 'contact.info.EMAIL_DETAIL' | translate }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>